export default function Footer() {
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-newspaper-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">国产黑料</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              一个把热传的国产黑料实锤截图、聊天记录、录音视频按时间分类收好的证据档案库。配合时间线和证据整理，点开就能复核，不用自己跨平台拼凑对比。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950">档案分类</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              {[
                { t: "实锤截图档案", href: "#shots" },
                { t: "聊天记录簿", href: "#chat" },
                { t: "录音视频卷宗", href: "#media" },
                { t: "证据整理包下载", href: "#pack" },
              ].map((l) => (
                <li key={l.t}>
                  <a href={l.href} className="hover:text-primary-700">
                    {l.t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-foreground-950">复核声明</h4>
            <p className="mt-4 text-xs leading-6 text-foreground-500">
              本站所有素材仅作公开信息的归纳与整理，供阅读者自行复核。凡未获多方实锤截图交叉验证的内容，均已明确标注为「推断」，不视为定论。如需删除或更正，欢迎通过站内联系入口说明。
            </p>
            <div className="mt-4 flex flex-col gap-2 text-xs text-foreground-500">
              <span className="flex items-center gap-2">
                <i className="ri-mail-send-line text-primary-600" /> archive@example.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600" /> 每日 09:00 定时归档校对
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 国产黑料 · 仅做信息整理，素材版权归原作者所有
          </p>
          <p className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-shield-check-line text-primary-600" />
            本页为静态展示，素材下载与联系均为示意
          </p>
        </div>
      </div>
    </footer>
  );
}